import styled from "styled-components";
import Color from "./../../assets/color";

const RestaurantStyle = styled.div`
  width: auto;

  .profile {
    width: 18rem;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;

    .restaurant-card-banner {
      padding-top: 50% !important ;
    }

    .restaurant-banner-image {
      height: 100%;
      top: 0;
      object-fit: cover;
    }

    .restaurant-card-body {
      background-color: white;
    }

    .restaurant-card-profile {
      position: relative;
      height: 37.5px;
    }

    .restaurant-card-profile img {
      height: 75px;
      width: 75px;

      z-index: 1;
      outline-style: solid;
      outline-color: white;
      outline-width: 6px;

      left: calc(50% - 37.5px);
      margin-top: -37.5px;

      object-fit: cover;
    }

    .text-success {
      color: ${Color.pistachio};
    }

    @media (max-width: 768px) {
      height: auto;
      width: 100%;
      max-width: 100%;
    }

    @media (max-width: 425px) {
      .restaurant-card-profile img {
        height: 70px;
        width: 70px;
        left: calc(50% - 35px);
        margin-top: -35px;
      }
    }
  }

  .restaurant-listing {
    background-color: ${Color.aliceBlue};

    .restaurant-image {
      width: 100px;
      height: 100px;
      flex-basis: 100px;

      img {
        object-fit: cover;
      }
    }

    .restaurant-number-of-review {
      color: ${Color.nobel};
    }

    .distance-tag {
      width: 60px;
      height: 60px;
      background-color: ${Color.white};
      color: ${Color.primary};
    }

    .restaurant-preferences-text {
      color: ${Color.nobel};
    }

    .delivery-fee {
      color: ${Color.primary};
    }

    .star-ratings {
      margin-left: auto !important ;
      margin-right: auto !important ;
    }

    @media (min-width: 1024px) and (max-width: 1280px) {
      width: auto;
      max-width: 100%;

      .restaurant-image {
        width: 80px !important;
        height: 80px !important;
        flex-basis: 80px !important;
      }
    }
  }

  .restaurant-card {
    max-width: 20rem;
    margin-left: auto;
    margin-right: auto;
    background-color: ${Color.aliceBlue};

    .restaurant-card-profile img {
      height: 60px;
      width: 60px;

      z-index: 1;
      outline-style: solid;
      outline-color: white;
      outline-width: 6px;

      left: calc(50% - 37.5px);
    }

    .text-success {
      color: ${Color.pistachio};
    }

    .text-danger {
      color: ${Color.razz};
    }

    @media (max-width: 768px) {
      width: 100%;
      max-width: 100%;
    }
  }

  .restaurant-menu-card {
    background-color: ${Color.aliceBlue};

    .restaurant-photo-container {
      position: relative;
      width: 100%;
      padding-top: 50%;
      margin-bottom: 1rem;

      .cover-photo {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .profile-photo {
        position: absolute;
        bottom: -1rem;
        left: 0.5rem;
        width: 80px;
        height: 80px;
        object-fit: cover;
        border: 3px solid ${Color.white};
      }

      .badge-status {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        max-width: calc(100% - 1rem);
        padding: 5px 8px;
        text-transform: uppercase;
        white-space: normal;
      }
    }

    .cuisine {
      color: ${Color.nobel};
    }
  }
`;

const RestaurantListCard = styled.div`
  height: 100%;
  .badge {
    white-space: unset;
  }

  .restaurant-list-card {
    height: 100%;
    padding-bottom: 1rem;
    color: ${Color.black};
    display: block;
    position: relative;

    :hover {
      text-decoration: none;
    }

    .preference {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 1rem;
      background-color: rgba(0, 0, 0, 0.8);
      border-radius: 4px;
      z-index: 11;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      color: ${Color.white};
      padding: 3rem;
      padding-top: 30%;
      padding-bottom: 30%;

      .preference-type {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .icon {
          width: 50px;
          height: 50px;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          border: 1px solid ${Color.white};
        }

        h4 {
          margin-top: 1rem;
          margin-bottom: 0;
        }
      }
    }

    .card-wrapper {
      height: 100%;
      border: 1px solid ${Color.athens};
      border-radius: 4px;

      .inner-container {
        padding: 1rem;
      }

      .restaurant-header {
        display: flex;

        .restaurant-name {
          margin-bottom: 5px;
          text-align: left;
        }

        .more {
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          border: 1px solid ${Color.black};
          z-index: 13;
        }
        .show {
          border: 1px solid ${Color.white};
        }
      }

      > .image-container {
        width: 100%;
        padding-top: 100%;
        position: relative;
        margin-bottom: 0.8rem;

        .image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
        }

        .flags {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 10;
          left: 0;
          top: -8px;
          padding: 0 1rem;

          .flag-wrapper {
            &.special-flags-wrapper {
              display: flex;
            }

            &.open-status-wrapper {
              margin-top: auto;
              margin-bottom: 0.5rem;
            }

            //+ .flag-wrapper {
            //  margin-top: 8px;
            //}

            div:not(:first-child) {
              margin-left: 0.5rem;
            }
          }

          .other-flag {
            display: flex;
            flex-direction: column;
          }

          .open-status {
            flex: 1;
            padding-left: 0.5rem;
            text-align: right;
          }

          .badge {
            padding: 5px 8px;
            text-transform: uppercase;
            text-transform: uppercase;

            + .badge {
              margin-left: 8px;
            }
          }
        }

        .open-status {
          width: 100%;
          position: absolute;
          z-index: 10;
          left: 0;
          bottom: -8px;
        }

        .dietary-container {
          display: flex;
          position: absolute;
          z-index: 10;
          right: 0;
          bottom: -17.5px;
          padding-right: 1rem;

          .icon {
            background: ${Color.athensGrey};
            border-radius: 100%;

            + .icon {
              margin-left: 5px;
            }
          }
        }
      }

      .category-container {
        display: flex;
        flex-wrap: wrap;

        .category {
          display: flex;
          align-items: center;
          margin-right: 1rem;

          .label {
            margin-left: 0.5rem;
            color: ${Color.emperor};
          }
        }
      }

      .order-type-container {
        display: flex;
        flex-wrap: wrap;
        padding-top: 0.5rem;

        .order-type {
          display: flex;
          align-items: center;
          margin-right: 1rem;
          margin-bottom: 0.5rem;

          .label {
            margin-left: 0.5rem;
          }
        }
      }

      .delivery-discount-container {
        margin-top: 0.5rem;
        margin-left: -1rem;
        margin-right: -1rem;

        .delivery-discount-label {
          background: ${Color.primary};
          padding: 0.5rem 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .delivery-discount-info {
          padding: 0.8rem 1rem;

          h5 {
            color: ${Color.primary};
            margin-bottom: 0.3rem;
            text-decoration: underline;
          }
          .delivery-discount-list {
            padding-left: 0;
            list-style: none;
            margin-bottom: 0;

            li {
              display: flex;

              .text {
                flex: 1;
                padding-left: 0.5rem;
                margin-top: 2px;
              }
            }
          }
        }
      }
    }

    .food-menu {
      margin-top: 0.5rem;
      .title {
        margin-bottom: 0;
        padding-bottom: 5px;
        border-bottom: 1px solid ${Color.athensGrey};
      }
      .product-container {
        padding-left: 0;
      }
    }

    .restaurant-voucher {
      margin-top: 0.5rem;

      .title {
        margin-bottom: 0;
        padding-bottom: 5px;
        border-bottom: 1px solid ${Color.athensGrey};
      }

      .voucher {
        display: flex;
        justify-content: space-between;
        padding: 0.5rem 0;
        border-bottom: 1px solid ${Color.athensGrey};

        .package-name {
          flex: 1;
        }
        .price {
          padding-left: 1rem;
          text-align: right;

          p {
            margin-bottom: 0;
          }
          .package-price {
            font-family: "Lato Bold", sans-serif;
          }
          .item-price {
            color: ${Color.nobel};
            text-decoration: line-through;
          }
        }
      }
    }
  }
`;
const RestaurantCardInfoStyled = styled.div`
  /*==== Restaurant Card Listing ====*/
  a.restaurant-card-link {
    .restaurant-card-info .info h3 {
      color: ${Color.black};
    }
    :hover {
      text-decoration: unset;
      .restaurant-card-info .info h3 {
        text-decoration: underline;
        color: ${Color.blazeOrange};
      }
    }
  }
  .restaurant-card-info {
    margin-bottom: 10px;
    .image {
      width: 120px;
      height: 120px;
      margin-right: 2.5em;
      .background {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        width: 100%;
        height: 100%;
      }
    }

    .info {
      p {
        color: ${Color.nandor};
        margin-bottom: 4px;
      }
      .restaurant-setting {
        p {
          margin-bottom: 5px;
          display: inline-block;
          span {
            padding: 0 2px;
          }
        }
        p:last-child span {
          display: none;
        }
      }
      .review {
        margin-bottom: 5px;
        p {
          margin-bottom: 0px;
          font-size: 14px;
        }
      }
      .ambience {
        p span {
          padding: 0 2px;
        }
        p:last-child span {
          display: none;
        }
      }
    }
  }
  /*==== END Restaurant Card Listing ====*/
  /*==== Restaurant Card Verticall ====*/
  a.restaurant-card-link {
    .restaurant-card-info-vertical .info h3 {
      color: ${Color.black};
    }
    :hover {
      text-decoration: unset;
      .restaurant-card-info-vertical .info h3 {
        text-decoration: underline;
        color: ${Color.blazeOrange};
      }
    }
  }
  .restaurant-card-info-vertical {
    text-align: left;
    margin-bottom: 10px;
    .image {
      width: 100%;
      height: 355px;
      margin-bottom: 15px;
      .background {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        width: 100%;
        height: 100%;
      }
    }
    .info {
      p {
        color: ${Color.emperor};
        margin-bottom: 8px;
      }
      .restaurant-setting {
        p {
          display: inline-block;
          color: ${Color.nobel};
          margin-bottom: 5px;
          font-size: 15px;
          span {
            padding: 0 2px;
          }
        }
        p:last-child span {
          display: none;
        }
      }
      .review {
        margin-bottom: 8px;
        p {
          color: ${Color.aluminium};
          margin-bottom: 0px;
          font-size: 14px;
        }
      }
      .ambience {
        p {
          margin-bottom: 0;
          display: table;
          float: left;
          line-height: 1.142rem;
        }
        p span {
          display: table-cell;
          vertical-align: middle;
          padding: 0;
        }
        p span:nth-child(2) {
          padding: 0 3px;
          font-weight: bolder;
          font-size: 22px;
        }
        p:last-child span {
          display: none;
        }
      }
    }
  }
  /*==== END Restaurant Card Verticall ====*/
`;

const RestaurantGridCardStyled = styled.div`
  height: 100%;
  padding-bottom: 1rem;

  a {
    .wrapper .information h3 {
      color: ${Color.black};
    }
    :hover {
      text-decoration: unset;
      .wrapper .information h3 {
        text-decoration: underline;
        color: ${Color.primary};
      }
    }
  }

  .wrapper {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    margin-bottom: 1.5rem;
    border: 1px solid ${Color.athens};

    @media (min-width: 768px) {
      width: 95%;
    }

    .custom-checkbox {
      position: absolute;
      top: 1px;
      z-index: 1;

      .custom-control-label::before {
        width: 30px;
        height: 30px;
      }

      .custom-control-input:checked ~ .custom-control-label::after {
        width: 30px;
        height: 30px;
        font-size: 24px;
      }
    }

    .delete {
      width: 30px;
      height: 30px;
      background-color: ${Color.white};
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      z-index: 1;
    }

    .image {
      position: relative;
      width: 100%;
      padding-top: 100%; /* 1:1 Aspect Ratio */

      img {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .information {
      padding: 1rem;

      .preference-text {
        color: ${Color.emperor};
        margin-bottom: 0;
      }

      .rating {
        display: flex;
        align-items: flex-end;
        margin-bottom: 0.25rem;

        span {
          margin-left: 5px;
          color: ${Color.emperor};
        }
      }

      .state {
        color: ${Color.emperor};
        margin-bottom: 3px;
      }

      .category {
        display: flex;
        flex-wrap: wrap;

        .category-item {
          display: flex;
          align-items: center;
          margin-right: 1rem;

          .label {
            margin-left: 0.5rem;
            color: ${Color.emperor};
          }
        }
      }
    }
  }
`;

const RatingStyled = styled.div`
  color: ${Color.aluminium};
  margin-bottom: 0.5rem;

  .rating-container {
    margin-left: 0.5rem;
    .total_rating {
      color: ${Color.emperor};
    }
    .total_vote {
      margin-left: 5px;
    }
  }
`;

export {
  RestaurantListCard,
  RestaurantCardInfoStyled,
  RestaurantGridCardStyled,
  RatingStyled,
};
export default RestaurantStyle;
